<template src="./allotment.pug" lang="pug"></template>

<script>
import TreeGrid from '../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../build/jsonToExcel/exportRoutes.js'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'Allotment',

  components: {
    TreeGrid
  },

  props: {
    showTreegridLot: {
      type: Boolean,
      required: false
    },
    resultLot: {
      type: Object,
      required: true
    },
    treeGridCfgLot: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      exportUrl: EXPORT_TREEGRID
    }
  },

  beforeUpdate () {
    if (document.querySelector("[aria-controls='#tab-lotes']")) {
      document.querySelector("[aria-controls='#tab-lotes']")
        .addEventListener('click', () => {
          trackAnalyticsEvent(this, 'conciliacao-manual', 'click-mudar-de-aba', 'tab-lotes')
        })
    }
  }
}
</script>

<style>
.bg-selected {
  background: #1d436a;
  opacity: 0.3;
}

.bg-unselected {
  background: #fff;
}

.select-label {
  text-transform: initial !important;
}

.selector-selected {
  color: #1d436a;
  font-weight: bold;
  margin: 3px!important;
}

.selector-unselected {
  color: #9e9b9b;
  margin: 3px!important;
}

.selector-icon {
  margin-right: 0.5vw;
}

.padded-table {
  padding-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// Allotment.vue?39c60a8a